import { cn } from '../utils/helpers/helper'
import Select, { ActionMeta, components, ControlProps, Props } from 'react-select'
import { ReactComponent as ChevronDown } from '../assets/icons/chevron-down.svg'

interface IDropdownProps {
  selected: {
    label: string
    value: string
  }
  options: Record<string, string>[]
  handleOptionChange: (newValue: unknown, actionMeta: ActionMeta<unknown>) => void
  className?: string
  label: string
}

const Control = ({
  children,
  ...rest
}: ControlProps & { children: React.ReactNode; label: string }) => (
  <components.Control
    className='border !border-coal-border rounded-[2px] !bg-jet-black-100'
    {...rest}
  >
    <div className='flex items-center gap-2 px-5 py-[14px]'>
      <span className='text-sm text-white font-medium'>{rest.label}</span>
      {children}
    </div>
  </components.Control>
)

const DropdownIndicator = () => <ChevronDown />

const CustomSelect = (props: Props & { label: string }) => {
  return (
    <Select
      {...props}
      components={{
        Control: (controlProps) => <Control {...controlProps} label={props.label} />,
        IndicatorSeparator: () => null,
        DropdownIndicator,
      }}
      styles={{
        singleValue: (base) => ({
          ...base,
          color: 'white',
          fontSize: '14px',
        }),
        valueContainer: (base) => ({
          ...base,
          padding: '0px',
        }),
        menu: (base) => ({
          ...base,
          backgroundColor: '#212121',
        }),
        option: (base, { isFocused, isSelected }) => ({
          ...base,
          color: 'white',
          fontSize: '14px',
          backgroundColor: isSelected ? '#202B46' : isFocused ? '#333333' : '#212121',
        }),
      }}
    />
  )
}

const Dropdown: React.FC<IDropdownProps> = ({
  options,
  handleOptionChange,
  selected,
  className,
  label,
}: IDropdownProps) => {
  return (
    <div className={cn('relative', className)}>
      <CustomSelect
        options={options}
        value={selected}
        onChange={handleOptionChange}
        label={label}
        isSearchable={false}
      />
    </div>
  )
}

export default Dropdown
